import { render, staticRenderFns } from "./InquiryFaktur.vue?vue&type=template&id=2a6c2b54&"
import script from "./InquiryFaktur.vue?vue&type=script&lang=js&"
export * from "./InquiryFaktur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports